import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AddFilter16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 1C4.87438 1 5.17787 1.30349 5.17787 1.67787V3.82214H7.32214C7.69652 3.82214 8.00001 4.12563 8.00001 4.5C8.00001 4.87438 7.69652 5.17787 7.32214 5.17787H5.17787V7.32214C5.17787 7.69652 4.87438 8.00001 4.5 8.00001C4.12563 8.00001 3.82214 7.69652 3.82214 7.32214V5.17787H1.67787C1.30349 5.17787 1 4.87438 1 4.5C1 4.12563 1.30349 3.82214 1.67787 3.82214H3.82214V1.67787C3.82214 1.30349 4.12563 1 4.5 1ZM9.35414 6.29163C8.97444 6.29163 8.66664 6.59944 8.66664 6.97913C8.66664 7.35883 8.97444 7.66664 9.35414 7.66664H14.3125C14.6922 7.66664 15 7.35883 15 6.97913C15 6.59944 14.6922 6.29163 14.3125 6.29163H9.35414ZM4.68746 11.3333L12.4792 11.3333C12.8589 11.3333 13.1667 11.0255 13.1667 10.6458C13.1667 10.2661 12.8589 9.95831 12.4792 9.95831H4.68746C4.30776 9.95831 3.99996 10.2661 3.99996 10.6458C3.99996 11.0255 4.30776 11.3333 4.68746 11.3333ZM7.43747 15L9.72915 15C10.1088 15 10.4166 14.6922 10.4166 14.3125C10.4166 13.9328 10.1088 13.625 9.72915 13.625H7.43747C7.05777 13.625 6.74997 13.9328 6.74997 14.3125C6.74997 14.6922 7.05777 15 7.43747 15Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
